export const TIME_FORMAT_OPTIONS = {
  "24hour": "24 hour",
  "12hour": "12 hour",
} as const;

export const DATE_FORMAT_OPTIONS = [
  { label: "yyyy/mm/dd", value: "yyyy/MM/dd" },
  { label: "mm/dd/yyyy", value: "MM/dd/yyyy" },
  { label: "dd/mm/yyyy", value: "dd/MM/yyyy" },
  { label: "dd/mmm/yyyy", value: "dd/MMM/yyyy" },
  { label: "dd mmm yyyy", value: "dd MMM yyyy" },
] as const;

export const CLIENT_DATE_TIME_DEFAULTS: Record<
  string,
  { dateFormat?: (typeof DATE_FORMAT_OPTIONS)[number]["value"] }
> = {
  collegiateeu: { dateFormat: "dd/MM/yyyy" },
};
